import React, { useState, useEffect } from "react";
import ComapanyNameDetails from "../../../../components/common/forms/ComapanyNameDetails";
import CompanySearch from "../../../../components/common/forms/CompanySearch";
import DetailsOfShareHolders from "../../../../components/common/forms/DetailsOfShareHolders";
import FormBranch from "../../../../components/common/forms/FormBranch";
import FormButtom from "../../../../components/common/forms/FormButtom";
import FormOtherDetails from "../../../../components/common/forms/FormOtherDetails";
import FormRadio from "../../../../components/common/forms/FormRadio";
import FormUploadDocument from "../../../../components/common/forms/FormUploadDocument";
import MainObjectives from "../../../../components/common/forms/MainObjectives";
import { galeru_registration_v2 } from "../GaleruRegistrationB";
import {
  galeru_registration,
  Gharelu_details_of_shareholder,
  ghaleru_shareholder,
  Gharelu_upload_details_v2,
} from "../GaleruRegistrationForm";
import { useForm } from "react-hook-form";
import FormPayment from "../../../../components/common/forms/FormPayment";
import Documents from "../../../../components/common/forms/Documents";
import { v4 as uuidv4 } from "uuid";
import { toast } from "react-toastify";
import api from "../../../../api/api";
import PrivateCompanyModal from "../../../../components/common/modal/CompanyFeeModal";
import { useSelector } from "react-redux";
import AdminSearchCustomer from "../../common/AdminSearchCustomer";


const GhareluCompanyRegistrationB = () => {
  const { register, handleSubmit, unregister } = useForm();
  const [docsOutput, setDocsOutput] = useState([])
  const [shareHolders, setShareHolders] = useState([
    {
      ...ghaleru_shareholder,
      id: uuidv4(),
    },
  ]);
  const [typeChange, setTypeChange] = useState(true)
  const [uploadProof, setUploadProof] = useState('')

  const { user, isSuccess } = useSelector((state) => state.auth);
  const [userID, setUserId] = useState(null)
  const [paymentRangeList, setPaymentList] = useState([])
  const [amount, setAmount] = useState(0)
  const [totalAmount, setTotalAmount] = useState(0)
  const [dueAmount, setDueAmount] = useState(null)
  const [paidAmount, setPaidAmount] = useState(null)


  useEffect(() => {
    if (typeChange) {
      galeru_registration_v2.map((item) => {
        unregister(item.name)
      })
    } else {
      galeru_registration.map((item) => {
        unregister(item.name)
      })
    }

  }, [unregister, typeChange])


  // For amount calculation
  useEffect(() => {
    if(amount > 0){
      let arr = paymentRangeList.filter((item) => { 
        return amount >= parseInt(item.range_start) && amount <= parseInt(item.range_end)
      })
      console.log(arr)

      arr.length > 0  && setTotalAmount(arr[0]?.amount)
    }else{
      setTotalAmount(0)
    }
  }, [amount, paymentRangeList])

   // getting current user
   useEffect(()=> {
    api.get("/users/me/")
    .then(response=> {
        setDueAmount(response.due_amount)
    }).catch(error=> {

    }) 
  },[])

   // for filtering by company_type and show in Modal
   useEffect(() => {
    api.get('/services/company/registration/service-charges/?company_type=gharelu_industry')
    .then(response=> {
        // console.log(response.data)
        setPaymentList(response.data)
    }).catch(error=> {
       console.log(error)
    })
  }, [])


  useEffect(()=> {
    setAmount(0)
  },[typeChange])







  const handleClick = (data) => {
    data.share_holders = shareHolders;
    data.documents = docsOutput;

    if (user?.user_type === "CL") {
      const user = JSON.parse(localStorage.getItem("user"));
      data.user = user.user_id;
    } else {
      if (userID !== null) {
        data.user = userID;
      }
    }

    api
      .post("/services/company/", data)
      .then((response) => {
        toast.success("Data Registered Successfully.");

        let transactions = {
          // payment_mode: "e_wallet",
          amount: paidAmount,
          service_object_id: response.data.registration_id,
          created_by: response.data.registration_id,
          service_object_content_type: response.data.service_content_type_id,
          payment_proof: uploadProof,
          company: response.data.company_id,
          transaction_type: "credit"

        };

        api
          .post("/transactions/", transactions)
          .then((response) => {
            toast.success("Data Registered 2 Successfully.");
          })
          .catch((error) => {
            toast.error("Error in Transaction");
          });



      })
      .catch((err) => {
        // console.log(err);
        toast.error("Data Registration Failed.");
      });

  }

  let data = []

  Gharelu_upload_details_v2.map((item, i) => {
    data.push({ id: uuidv4(), image: "", document_name: "" })
    return ''
  })


  return (
    <div>
      <form className="">
        <div className="mt-3">
          {(user?.user_type === "ST" || user?.user_type === "AD") && (
            <AdminSearchCustomer setUserId={setUserId} />
          )}
        </div>
        <div className="flex justify-between my-4">
          <p className="text-primary-blue font-Calistoga text-lg underline">
            1. Company Name Details
          </p>
          <p className="text-primary-red flex">
            Firm No.
            <span className=" text-primary-blue"> 1234</span>
          </p>
        </div>
        <CompanySearch register={register} />
        <ComapanyNameDetails register={register} />
        <p className="text-primary-blue font-Calistoga text-lg my-4 underline">2. Others Details</p>
        <FormRadio register={register} setTypeChange={setTypeChange} />



        <div className="flex md:flex-col-1  gap-3 items-center">
          <div>

            {
              typeChange === true ?
                <div className=" mt-4 border-primary-blue md:w-[40rem] border-2 font-bold">
                  {galeru_registration.map((item, i) => {
                    const { name, validation, ip1, type } = item;
                    return (
                      <div
                        key={i}
                        className="border-primary-blue flex flex-col border-b md:flex-row"
                      >
                        <p className="text-primary-red font-Laila px-5 py-2 sm:!w-[350px]">
                          {ip1}
                        </p>
                        <input
                          type={type}
                          className="border-primary-blue w-full border-t md:border-t-0 py-2 pl-3 outline-none md:border-l-2 "

                          {...register(`${name}`, { required: false,
                          onChange: (e) => {e.target.name === "total_capital" && setAmount(e.target.value)} })}

                          
                        

                        />

                      </div>
                    );
                  })}
                  <div className="text-primary-blue max-w-3xl px-5 font-Laila py-2 text-center">
                    पुँजीको आधारमा तपाईको जम्मा लाग्ने रकम
                    <span className="text-red-600">रु.{totalAmount}।–</span> मात्र
                  </div>
                </div>
                :

                <div className=" mt-4 border-primary-blue md:w-[40rem] border-2 font-bold">
                  {galeru_registration_v2.map((item, i) => {
                    const { name, validation, ip1, type } = item;
                    console.log(item);
                    return (
                      <div
                        key={i}
                        className="border-primary-blue flex flex-col border-b md:flex-row"
                      >
                        <p className="text-primary-red font-Laila px-5 py-2 sm:!w-[350px]">
                          {ip1}
                        </p>
                        <input
                          type={type}
                          className="border-primary-blue w-full md:border-t-0 border-t py-2 pl-3 outline-none md:border-l-2"

                          {...register(`${name}`, { required: false,
                           onChange: (e) => {e.target.name === "capital_to_invest" && setAmount(e.target.value)} })}

                          
                          

                        />

                      </div>
                    );
                  })}
                  <div className="text-primary-blue max-w-3xl px-5 font-Laila border-t border-primary-blue py-2 text-center">
                    साझेदार संख्या र  पुँजीको आधारमा तपाईको जम्मा लाग्ने रकम
                    <span className="text-red-600">रु.{totalAmount}।–</span> मात्र
                  </div>
                </div>

            }
          </div>
          <div>
            <div className="border-primary-red text-primary-blue w-fit rounded-full text-sm border-2 p-2 ">
              घरेलु तथा साना उद्योग कार्यालय मार्फत वाणिज्य शाखामा ब्यवसाय दर्ता गर्दा लाग्ने शुल्क सम्बन्धि पूर्ण जानकारी लिनको लागि यहाँ
              <span
                data-bs-toggle="modal"
                data-bs-target="#exampleModalEdit"
                className="text-primary-red cursor-pointer"
              >
                Click
              </span>
              गर्नुहोस ।
              <PrivateCompanyModal paymentRangeList={paymentRangeList} />

            </div>
          </div>
        </div>


        {/* <table className="mt-4">
          <thead>
            <tr>
              {galeru_registration_v2.map((item, i) => {
                const { name, validation, ip1, type } = item;
                console.log(item);
                return (
                  <div
                    key={i}
                    className="border-primary-blue flex flex-col md:flex-row"
                  >
                    <td className="border-primary-blue text-primary-red border px-10 text-lg font-bold">
                      {ip1}
                    </td>
                    <td className="border-primary-blue text-primary-red border px-10 text-lg font-bold">
                      <input type={type}
                       {...register(`${name}`, { required: false })}
                      
                      />
                    </td>
                  </div>
                );
              })}
            </tr>
          </thead>
        </table> */}

        <p className="text-primary-blue font-Calistoga text-lg my-3 underline">
          3. Details of Share Holders
        </p>

        {/* details of share holders open */}
        {/* <div className="">
          <div className="flex justify-end">
            <a className="add-record cursor-pointer" data-added={0}>
              <i className="">
                <svg
                  className="text-primary-blue h-8 w-8"
                  xmlns="http://www.w3.org/2000/svg"
                  aria-hidden="true"
                  role="img"
                  preserveAspectRatio="xMidYMid meet"
                  viewBox="0 0 32 32"
                >
                  <path
                    fill="currentColor"
                    d="M16 2A14.172 14.172 0 0 0 2 16a14.172 14.172 0 0 0 14 14a14.172 14.172 0 0 0 14-14A14.172 14.172 0 0 0 16 2Zm8 15h-7v7h-2v-7H8v-2h7V8h2v7h7Z"
                  />
                  <path fill="none" d="M24 17h-7v7h-2v-7H8v-2h7V8h2v7h7v2z" />
                </svg>
              </i>
            </a>
          </div>
          {/* share holder details form */}
        {/* <div className="flex flex-col">
            <div className="overflow-x-auto sm:-mx-6 lg:-mx-8">
              <div className="inline-block min-w-full py-2 sm:px-6 lg:px-8">
                <div className="min-w-[1300px] overflow-x-auto">
                  <table id="tbl_posts">
                    <thead>
                      <tr>
                        <td className="border-primary-blue  text-primary-red border text-lg font-bold">
                          क्र. स.
                        </td>
                        <td className="border-primary-blue text-primary-red border text-base font-bold sm:text-lg">
                          साझेदार सदस्यहरुको नाम
                        </td>
                        <td className="border-primary-blue text-primary-red border text-base font-bold sm:text-lg">
                          हालको ठेगाना
                        </td>
                        <td className="border-primary-blue text-primary-red border text-base font-bold sm:text-lg">
                          लगानी गर्ने शेयरको प्रतिशत
                        </td>
                        <td className="border-primary-blue text-primary-red border text-base font-bold sm:text-lg">
                          लगानी गर्ने शेयर रकम
                        </td>

                        <td className="border-primary-blue text-primary-red border border-r-0 text-base font-bold sm:text-lg">
                          शेयर सदस्यको नागरिकता
                        </td>
                        <td className="border-primary-blue text-primary-red border border-r text-base font-bold sm:text-lg">
                          पासपोर्ट साईजको फोटो
                        </td>
                      </tr>
                    </thead>
                    <tbody id="tbl_posts_body">
                      <tr id="rec-1" className="border-primary-blue border">
                        <td className="text-primary-red border-primary-blue border-r px-10 text-center font-semibold">
                          1
                        </td>
                        <td className="p-0">
                          <input
                            type="text"
                            name=""
                            className="border-primary-blue text-primary-blue m-0 h-[54px] w-full border-r py-3 px-3 outline-none"
                            id=""
                          />
                        </td>
                        <td className="p-0">
                          <input
                            type="text"
                            name=""
                            className="border-primary-blue text-primary-blue m-0 h-[54px] w-full border-r py-3 px-3 outline-none"
                            id=""
                          />
                        </td>
                        <td className="p-0">
                          <input
                            type="text"
                            name=""
                            className="border-primary-blue text-primary-blue m-0 h-[54px] w-full border-r py-3 px-3 outline-none"
                            id=""
                          />
                        </td>
                        <td className="p-0">
                          <input
                            type="text"
                            name=""
                            className="border-primary-blue text-primary-blue m-0 h-[54px] w-full border-r py-3 px-3 outline-none"
                            id=""
                          />
                        </td>
                        <td className="p-0">
                          <input
                            type="file"
                            name=""
                            className="border-primary-blue file:bg-primary-blue h-[54px] w-full cursor-pointer border-r py-3 px-3 outline-none file:rounded-2xl file:text-white"
                            id=""
                          />
                        </td>

                        <td className="p-0">
                          <input
                            type="file"
                            name=""
                            className="border-primary-blue file:bg-primary-blue m-0 w-full cursor-pointer py-3 px-3 outline-none file:rounded-2xl file:text-white"
                            id=""
                          />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  {/* <div style={{ display: "none" }}>
                    {/* table row add */}
        {/* <table id="sample_table">
                      <tbody>
                        <tr id="" className="border-primary-blue border">
                          <td className="text-primary-red border-primary-blue border-r px-10 text-center font-semibold">
                            <span className="sn">1</span>
                          </td>
                          <td className="p-0">
                            <input
                              type="text"
                              name=""
                              className="border-primary-blue text-primary-blue m-0 h-[54px] w-full border-r py-3 px-3 outline-none"
                              id=""
                            />
                          </td>
                          <td className="p-0">
                            <input
                              type="text"
                              name=""
                              className="border-primary-blue text-primary-blue m-0 h-[54px] w-full border-r py-3 px-3 outline-none"
                              id=""
                            />
                          </td>
                          <td className="p-0">
                            <input
                              type="text"
                              name=""
                              className="border-primary-blue text-primary-blue m-0 h-[54px] w-full border-r py-3 px-3 outline-none"
                              id=""
                            />
                          </td>
                          <td className="p-0">
                            <input
                              type="file"
                              name=""
                              className="border-primary-blue file:bg-primary-blue m-0 w-full cursor-pointer border-r py-3 px-3 outline-none file:rounded-2xl file:text-white"
                              id=""
                            />
                          </td>
                          <td className="p-0">
                            <input
                              type="text"
                              name=""
                              className="border-primary-blue text-primary-blue m-0 h-[54px] w-full border-r py-3 px-3 outline-none"
                              id=""
                            />
                          </td>
                          <td className="p-0">
                            <input
                              type="text"
                              name=""
                              className="border-primary-blue text-primary-blue m-0 h-[54px] w-full border-r py-3 px-3 outline-none"
                              id=""
                            />
                          </td>
                          <td className="p-0">
                            <input
                              type="file"
                              name=""
                              className="border-primary-blue file:bg-primary-blue m-0 w-full cursor-pointer py-3 px-3 outline-none file:rounded-2xl file:text-white"
                              id=""
                            />
                          </td>
                          <td className="">
                            <a href="" className="delete-record">
                              <svg
                                className="text-primary-red h-8 w-8"
                                xmlns="http://www.w3.org/2000/svg"
                                aria-hidden="true"
                                role="img"
                                preserveAspectRatio="xMidYMid meet"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  fill="currentColor"
                                  d="M19.1 4.9C15.2 1 8.8 1 4.9 4.9S1 15.2 4.9 19.1s10.2 3.9 14.1 0s4-10.3.1-14.2zm-4.3 11.3L12 13.4l-2.8 2.8l-1.4-1.4l2.8-2.8l-2.8-2.8l1.4-1.4l2.8 2.8l2.8-2.8l1.4 1.4l-2.8 2.8l2.8 2.8l-1.4 1.4z"
                                />
                              </svg>
                            </a>
                          </td>
                        </tr>
                      </tbody>
                    </table> */}
        {/* </div> */}
        {/* </div>
              </div>
            </div>
          </div> 
        </div>  */}
        {/* details of share holders close */}

        <DetailsOfShareHolders
          DetailShareholder={Gharelu_details_of_shareholder}
          needed_share={ghaleru_shareholder}
          setShareHolders={setShareHolders}
          shareHolders={shareHolders}
        />


        <div className="text-primary-blue font-Calistoga text-lg my-3 underline">
          4. Main Objectives    <span className="text-primary-blue font-Laila">  (कम्पनीले गर्ने मुख्य मुख्य कामहरु सहितको उद्देश्यहरु) </span>
        </div>

        <MainObjectives register={register} />


        {/* upload document */}
        <div className="text-primary-blue font-Calistoga text-lg my-4 underline">
          5. Upload Documents    <span className="text-primary-blue font-Laila">  (यो ब्यसाय दर्ताको लागि आवश्यक पर्ने निम्न कागजपत्रहरु   <span className="text-red-600">Upload</span> गर्नुहोस ।</span>
        </div>
        <Documents
          documents_data={Gharelu_upload_details_v2}
          initialState={data}
          setDocument={setDocsOutput} />

        {/* <table>
          <thead>
            <tr>
              <td className="border-primary-blue text-primary-red border px-10 text-lg font-bold">
                S. N.
              </td>
              <td className="border-primary-blue text-primary-red border px-20 text-base font-bold sm:text-lg">
                Document Name
              </td>
              <td className="border-primary-blue text-primary-red border px-20 text-base font-bold sm:text-lg">
                Action
              </td>
              <td className="border-primary-blue text-primary-red border px-20 text-base font-bold sm:text-lg">
                Remarks
              </td>
            </tr>
          </thead>
          <tbody>
            {Gharelu_upload_details.map((item, index) => {
              return (
                <tr className="border-primary-blue border">
                  <td className="text-primary-red border-primary-blue border-r px-10 text-center font-semibold">
                    {item.sn}
                  </td>
                  <td className="p-0">
                    <p className="border-primary-blue text-primary-blue font-semibold m-0 h-[54px] w-full border-r py-3 px-3 outline-none">
                      {item.ip1}
                      <button className="bg-primary-blue text-white rounded-xl ml-3 px-2">
                        Upload
                      </button>
                    </p>
                  </td>
                  <td className="p-0">
                    <div className="border-primary-blue text-white m-0 h-[54px] w-full border-r py-3 px-3 outline-none space-x-2">
                      <button className="bg-primary-green rounded-xl px-2 ">
                        view
                      </button>
                      <button className="bg-primary-red rounded-xl px-2">
                        Delete
                      </button>
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table> */}
        {/* upload document close */}
        <div className="text-primary-blue font-Calistoga text-lg my-3 underline">
          6. Working Branch   <span className="text-primary-blue font-Laila">  (तपाईले दर्ता गर्न खोज्नुभएको कम्पनी रहने ठेगाना नजिक हाम्रो कुन शाखा नजिक पर्छ छनोट गर्नुहोस् ।)</span>
        </div>
        <FormBranch register={register} />
        <FormButtom />
        <FormPayment handleSubmit={handleSubmit}
          handleClick={handleClick}
          setUploadProof={setUploadProof}
          totalAmount={totalAmount}
          dueAmount = {dueAmount}
          setPaidAmount = {setPaidAmount}
        />

      </form>
    </div>
  );
};

export default GhareluCompanyRegistrationB;
